import '../../css/src/program_directory.scss';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Fuse from 'fuse.js';
import ListComponent from '../components/campaigns_directory/ListComponent.vue';
import CardComponent from '../components/campaigns_directory/CardComponent.vue';
import TopCampaigns from '../components/campaigns_directory/TopCampaignsComponent.vue';

Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
});

Vue.component('list-component', ListComponent);
Vue.component('card-component', CardComponent);
Vue.component('top-campaigns', TopCampaigns);

new Vue({
    el: '#app',
    router,
    data: {
        listStyle: window.innerWidth < 992 ? 'card' : 'list', // list || cards
        companies: [],
        currentPage: 0,
        pageSize: 22,
        categories: [],
        countryCultures: [],

        // Search data
        searchProgram: '',
        selectedPayouts: [],
        payoutsList: false,
        searchCategory: '',
        selectedCategories: [],
        categoriesList: false,
        searchCountry: '',
        selectedCountries: [],
        countriesList: false,
        filteredCompanies: {},
        totalFilteredCampaigns: 0,
    },
    components: {
        ListComponent,
        CardComponent,
        TopCampaigns,
    },
    methods: {
        goToPage(index) {
            document.querySelector('.top-campaigns').scrollIntoView({
                behavior: 'smooth', block: 'end',
            });
            this.currentPage = index - 1;
            this.$router.push({ query: { ...this.$route.query, campaignPage: this.currentPage } });
        },
        navigate(direction) {
            switch (direction) {
            case 'previous':
                this.currentPage -= 1;
                break;

            default:
                this.currentPage += 1;
                break;
            }
            this.$router.push({ query: { ...this.$route.query, campaignPage: this.currentPage } });
            this.scrollTo('.programs-header');
        },
        setPageSize(size) {
            this.pageSize = size;
            this.$router.push({ query: { ...this.$route.query, perPage: this.pageSize } });
        },
        scrollTo(target) {
            document.querySelector(`${target}`).scrollIntoView({
                behavior: 'smooth',
            });
        },
        getCategory(category) {
            const found = this.categories.find(
                (target) => target.id === category,
            );
            return found.label;
        },
        removeFilter(type, value) {
            this[type] = this[type].filter((each) => each !== value);
        },
        closeAll() {
            this.payoutsList = false;
            this.categoriesList = false;
            this.countriesList = false;
        },
        handleSearch() {
            if (this.$refs.searchInput.value.length === 0) {
                this.searchProgram = '';
                this.$refs.searchInput.classList.remove('has-error');
            } else if (this.$refs.searchInput.value.length < 3) {
                this.$refs.searchInput.classList.add('has-error');
            } else {
                this.$refs.searchInput.classList.remove('has-error');
                this.searchProgram = this.$refs.searchInput.value;
                this.currentPage = 0;
                document.querySelector('.top-campaigns-list').scrollIntoView({
                    behavior: 'smooth',
                });
            }
        },
        stopPropagation(e) {
            e.stopPropagation();
        },
        goToShortcut(countries = [], categories = [], payouts = []) {
            // Prepare the Info
            this.currentPage = 0;
            this.searchProgram = '';
            this.selectedCountries = [];
            this.selectedCategories = [];
            this.selectedPayouts = [];

            // Handle Country
            this.selectedCountries = this.countryCultures.filter((country) => countries.some((query) => country.cultureInfoCode === query));

            // Handle Categories
            categories.forEach((category) => {
                this.selectedCategories.push(category);
            });

            // Handle Payouts
            payouts.forEach((payout) => {
                this.selectedPayouts.push(payout);
            });
            document.querySelector('.shortcuts').scrollIntoView({
                behavior: 'smooth', block: 'start',
            });
        },
        focusInput(target){
            this.$nextTick(() => this.$refs[target].focus());

        },
    },
    mounted() {
        // Get all the info to fill the page
        $.getJSON('/wp-json/kwanko_api/campaigns')
            .then((data) => {
                this.companies = data.reverse();
            });

        $.getJSON('/wp-content/themes/kwankotheme/assets/js/json/cultures.json')
            .then((data) => {
                this.countryCultures = data;
            })
            .then(() => {
                if (this.$route.query.countries) {
                    const countryQuery = this.$route.query.countries.split(',');
                    this.selectedCountries = this.countryCultures.filter((country) => countryQuery.some((query) => country.cultureInfoCode === query));
                }
            });

        $.getJSON(`/wp-json/kwanko_api/categories/${(window.language).substring(0, 2)}`)
            .then((categories) => {
                this.categories = categories ?? [];
            })
            .then(() => {
                if (this.$route.query.vertical) {
                    this.selectedCategories = this.$route.query.vertical.split(',').map(Number);
                }
            });

        // Query parameters
        if (this.$route.query.campaignPage) {
            this.currentPage = parseInt(this.$route.query.campaignPage, 10);
        }
        if (this.$route.query.perPage) {
            this.pageSize = parseInt(this.$route.query.perPage, 10);
        }
        if (this.$route.query.search) {
            this.searchProgram = this.$route.query.search;
        }
        if (this.$route.query.payouts) {
            this.selectedPayouts = this.$route.query.payouts.split(',');
        } else {
            this.$router.push({ query: { ...this.$route.query, perPage: this.pageSize } }).catch(() => {
            });
        }

        // Add event listener to close dropdowns
        document.getElementById('app').addEventListener('click', this.closeAll());
    },
    computed: {
        pageCount() {
            return Math.ceil(this.totalFilteredCampaigns / this.pageSize);
        },
        paginatedCampaigns() {
            const start = this.currentPage * this.pageSize;
            const end = start + this.pageSize;
            let filteredCompanies = this.companies;

            if (this.selectedPayouts.length) {
                filteredCompanies = filteredCompanies.filter((company) => this.selectedPayouts.some((payout) => company.payout_modes.includes(payout)));
            }
            if (this.selectedCategories.length) {
                filteredCompanies = filteredCompanies.filter((company) => this.selectedCategories.some((category) => (company.iab_categories ? company.iab_categories.includes(category) : false)));
            }
            if (this.selectedCountries.length) {
                filteredCompanies = filteredCompanies.filter((company) => this.selectedCountries.some((country) => (company.cultures ? company.cultures.includes(country.cultureInfoCode) : false)));
            }
            if (this.searchProgram.length >= 3) {
                const options = {
                    threshold: 0.15,
                    minMatchCharLength: 3,
                    keys: [
                        'name',
                    ],
                };

                const fuse = new Fuse(filteredCompanies, options);
                const searchResults = fuse.search(this.searchProgram);

                filteredCompanies = [];
                searchResults.forEach((result) => {
                    filteredCompanies.push(result.item);
                });
            }
            if (this.searchProgram.length < 3 && !this.selectedPayouts.length && !this.selectedCategories.length && !this.selectedCountries.length) {
                filteredCompanies = this.companies;
            }

            filteredCompanies = [...new Set(filteredCompanies)];
            this.totalFilteredCampaigns = filteredCompanies.length;

            return filteredCompanies.slice(start, end);
        },
        filteredCountries() {
            if (this.searchCountry.length >= 3) {
                const options = {
                    threshold: 0.15,
                    minMatchCharLength: 3,
                    keys: [
                        'country',
                    ],
                };

                const fuse = new Fuse(this.usedCountries, options);
                const filteredCountries = [];
                const searchResults = fuse.search(this.searchCountry);

                searchResults.forEach((result) => {
                    filteredCountries.push(result.item);
                });
                return filteredCountries;
            }
            return this.usedCountries;
        },
        filteredCategories() {
            if (this.searchCategory.length >= 3) {
                const options = {
                    threshold: 0.15,
                    minMatchCharLength: 3,
                    keys: [
                        'label',
                    ],
                };

                const fuse = new Fuse(this.usedCategories, options);
                const filteredCategories = [];
                const searchResults = fuse.search(this.searchCategory);

                searchResults.forEach((result) => {
                    filteredCategories.push(result.item);
                });
                return filteredCategories;
            }
            return this.usedCategories;
        },
        paginationPages() {
            return Array.from(Array(this.pageCount).keys()).splice(this.currentPage, 5);
        },
        topCampaigns() {
            let campaignIds = window.topCampaign.replace(' ', '');
            campaignIds = campaignIds.split(',');
            const result = [];
            campaignIds.forEach((campaignId) => {
                for (let i = 0, iLen = this.companies.length; i < iLen; i += 1) {
                    if (this.companies[i].id === parseInt(campaignId, 10)) {
                        result.push(this.companies[i]);
                    }
                }
            });
            return result;
        },
        usedCategories() {
            return this.categories.filter((category) => this.companies.some((company) => (company.iab_categories ? company.iab_categories.includes(category.id) : false)));
        },
        usedCountries() {
            return this.countryCultures.filter((country) => this.companies.some((company) => (company.cultures ? company.cultures.includes(country.cultureInfoCode) : false)));
        },
    },
    watch: {
        // whenever question changes, this function will run
        searchProgram() {
            this.$router.push({ query: { ...this.$route.query, search: this.searchProgram } }).catch(() => {
            });
        },
        selectedPayouts() {
            this.$router.push({ query: { ...this.$route.query, payouts: this.selectedPayouts.join(',') } }).catch(() => {
            });
        },
        selectedCategories() {
            this.$router.push({
                query: {
                    ...this.$route.query,
                    vertical: this.selectedCategories.join(','),
                },
            }).catch(() => {
            });
        },
        selectedCountries() {
            const countryIds = [];
            this.selectedCountries.forEach((country) => {
                countryIds.push(country.cultureInfoCode);
            });
            this.$router.push({ query: { ...this.$route.query, countries: countryIds.join(',') } }).catch(() => {
            });
        },
    },

});

